export default function(path){
    let start = "https://cube.elemecdn.com/";
    let end = "?x-oss-process=image/resize,w_130,h_130,m_fixed";
    let p = path.substr(0,1) + "/" + path.substr(1,2) + "/" + path.substr(3);
    let suffix = path.substr(-3);
    switch (suffix) {
        case "png":
            suffix = ".png";
            break;
        case "jpg":
            suffix = ".jpg";
            break;
        case "peg":
            suffix = ".jpeg";
            break;
        default:
            break;
    }
    return start + p + suffix + end;
}